export const SITE_NAME = 'Coming Soon | Africa Bridges';
export const SITE_URL = 'https://africabridges-soon.netlify.app';
export const SITE_DESC = 'Africa Bridges Is Coming Soon.';
export const SITE_IMG = 'https://ab-web-prod.s3.amazonaws.com/assets/ab_logo_brown_short_text.png';
